import { render } from "./TermsModal.vue?vue&type=template&id=4da1ca5f&ts=true"
import script from "./TermsModal.vue?vue&type=script&lang=ts"
export * from "./TermsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__